import { buildRuleMeta, metas, MetaType } from '@src/pages/workflow/workflow-utils'
import { isEmpty } from 'lodash'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'

type RuleMeta = {
  section: TemplateSection | undefined
  meta: MetaType
}

type UseProcessWorkflowEndDateResult = [
  FutureDate | null,
  Dispatch<SetStateAction<FutureDate | null>>,
  boolean,
  RuleMeta | null,
]

export function useProcessWorkflowEndDate(
  template: Template | null | undefined,
  sections: TemplateSection[],
  startDate: FutureDate | null,
): UseProcessWorkflowEndDateResult {
  const [processedEndDate, setProcessedEndDate] = useState<FutureDate | null>(null)
  const [selectedEndDate, setSelectedEndDate] = useState<FutureDate | null>(null)
  const [ruleMeta, setRuleMeta] = useState<RuleMeta | null>(null)
  const endDateIsGenerated = ruleMeta?.meta === metas.RECURRENCE_AND_REPEAT

  useEffect(() => {
    if (template && !isEmpty(template)) {
      const { section, meta, endDate } = buildRuleMeta(sections, startDate)
      if (endDate) {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        setProcessedEndDate({
          date: endDate.toISO()!,
          timeZone,
        })
      } else {
        setProcessedEndDate(selectedEndDate)
      }
      setRuleMeta({ section, meta })
    }
  }, [template, startDate, selectedEndDate, sections])

  return [processedEndDate, setSelectedEndDate, endDateIsGenerated, ruleMeta]
}
